import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MapMarkerService {
  closeAllPreviews() {
    document.querySelectorAll('.item-preview').forEach((el) => {
      el.classList.remove('flex');
      el.classList.add('hidden');
      el.parentElement?.parentElement?.parentElement?.classList.remove('z-10');
    });
  }
}
